import React, { Fragment, useRef, useEffect, useState } from 'react';
//import { observer } from 'mobx-react'; 
import { CollapseMenu } from 'cd-eft/components/common/CollapseMenu';

interface ISummaryProps {
    title?: string;
    design: number;
}

interface IDetailsProps {
    className?: string;
    toolName?: string;
}

export const GroundSurfaceDetails = (props: IDetailsProps) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                Items displayed in red have been changed since the
                initial {props.toolName === "Terrace" ? "terrace" : "waterway"} design calculations were completed.
                Calculation results from the previous {props.toolName === "Terrace" ? "terrace" : "waterway"} design may be invalid.
            </p>
            <p>
                <strong>{props.toolName === "Terrace" ? "The Surface" : "The Ground Surface"} warning</strong> indicates
                {props.toolName === "Terrace" ? " the original surface" : " the original ground surface"} generated from a X, Y, Z
                survey or from a DEM has been changed. The alignment and any digitized reaches will remain, but the results
                from the {props.toolName === "Terrace" ? "terrace" : "waterway"} design calculations
                will need to be redesigned or recalculated.
            </p>
            <p>
                To Resolve:
            </p>
            <ol type='a'>
                <li>Make any necessary edits in the Alignment Tool and save changes.  </li>
            </ol>
        </div>
    );
};

export const AlignmentWarnDetails = (props: IDetailsProps) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                Items displayed in red have been changed since the initial {props.toolName === "Terrace" ? "terrace" : "waterway"} design
                calculations were completed.
                Calculation results from the previous {props.toolName === "Terrace" ? "terrace" : "waterway"} design may be invalid.
            </p>
            <p>
                <strong>The Alignment warning</strong> indicates the alignment selected in
                the {props.toolName === "Terrace" ? "Terrace" : "Waterway"} Inputs page has either
                been updated in the Alignment Tool, or a different alignment has been selected
                in the {props.toolName === "Terrace" ? "Terrace" : "Waterway"} Inputs. Digitized
                reaches will remain, if possible, but {props.toolName === "Terrace" ? "terrace" : "waterway"} design calculations
                will need to be redesigned or recalculated.
            </p>
            <p>
                To Resolve:
            </p>
            <ol type='a'>
                <li>Change the selected alignment in the {props.toolName === "Terrace" ? "Terrace" : "Waterway"} Inputs back
                    to the originally selected alignment; </li>

                <li>
                    Or update any Reaches needing to be modified due to the changed alignment and recalculate the reach
                    or reaches.
                </li>
            </ol>
        </div>
    );
};

export const DesignControlsWarnDetails = (props: { className?: string }) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                Items displayed in red have been changed since the initial waterway design calculations were completed.
                Calculation results from the previous waterway design may be invalid.
            </p>
            <p>
                <strong>The Design Controls warning</strong> indicates changes have been made in the Design Controls section
                of the Waterway Inputs page.
            </p>
            <ol type='a'>
                <li>Changes to the Fill Controls may invalidate previous fill calculations. </li>

                <li>Changes to the Channel Ends may invalidate previous cut and fill calculations as well as potentially changing
                    the upstream most reach, the downstream most reach, or both. </li>

                <li>Changing the Freeboard will result in previous cut and fill calculations being invalid. </li>

                <li>To resolve review any updated Reaches and recalculate all the reaches.</li>
            </ol>
        </div>
    );
};

export const PeakFlowQDetails = (props: IDetailsProps) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                Items displayed in red have been changed since the initial {props.toolName === "Terrace" ? "terrace" : "waterway"} design
                calculations were completed.
                Calculation results from the previous {props.toolName === "Terrace" ? "terrace" : "waterway"} design may be invalid.
            </p>
            <p>
                <strong>{props.toolName === "Terrace" ? "The Hydrology" : "The Peak Flow Q"} warning</strong> indicates
                the peak flow Q, the initial Q fraction, or both
                have been changed since the initial {props.toolName === "Terrace" ? "terrace" : "waterway"} design calculations
                were completed or a different Hydrology Project
                may have been chosen in the dropdown.
            </p>
            <p>
                To Resolve:
            </p>
            <ol type='a'>
                <li>Either change the values back to the initial values, </li>
                <li>
                    Or use Save and Proceed to go the {props.toolName === "Terrace" ? "Terrace" : "Waterway"} Design page
                    and recalculate the reaches with the revised Q information.
                </li>
            </ol>
        </div>
    );
};

export const ReachesWarnDetails = (props: IDetailsProps) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                Items displayed in red have been changed since the initial {props.toolName === "Terrace" ? "terrace" : "waterway"} design
                calculations were completed.
                Calculation results from the previous {props.toolName === "Terrace" ? "terrace" : "waterway"} design may be invalid.
            </p>
            <p>
                <strong>The Reaches warning</strong> indicates the digitized reaches have been changed
                in the {props.toolName === "Terrace" ? "Terrace" : "Waterway"} Design
                page and Saved, but {props.toolName === "Terrace" ? "terrace" : "waterway"} design calculations have not been
                completed with the modified reaches.
            </p>
            <p>
                To Resolve:
            </p>
            <ol type='a'>
                <li>Review any updated reaches and recalculate all the reaches,</li>

                <li>Selecting all reaches, </li>

                <li>And applying to selected reaches. </li>

                <li>Or use Save and Calculate at the bottom of the Reach Table. </li>
            </ol>
        </div>
    );
};

export const PlaceholderDesignControlDetailsforTerrace = (props: IDetailsProps) => {
    return (
        <div className={props.className ? props.className : ''} tabIndex={0}>
            <p>
                Placeholder Text for Terrace Design Control Warning Notification.
            </p>
        </div>
    );
};

export const PopupContainer = (props: ISummaryProps) => {
    if (props.title === undefined && props.design === 4) {
        return (
            <div className='Waterway-Summary-Details'>
                <CollapseMenu
                    titleClass={'waterway-summary-details-menu'}
                    noIcon={true}
                    title={'Ground Surface'}
                    isOpen={true}
                >
                    <GroundSurfaceDetails className="" toolName=""></GroundSurfaceDetails>
                </CollapseMenu>
                <CollapseMenu
                    titleClass={'waterway-summary-details-menu'}
                    noIcon={true}
                    title={'Alignment Warning'}
                    isOpen={true}
                >
                    <AlignmentWarnDetails className="" toolName=""></AlignmentWarnDetails>
                </CollapseMenu>
                <CollapseMenu
                    titleClass={'waterway-summary-details-menu'}
                    noIcon={true}
                    title={'Design Controls Warning'}
                    isOpen={true}
                >
                    <DesignControlsWarnDetails className="" ></DesignControlsWarnDetails>
                </CollapseMenu>
                <CollapseMenu
                    titleClass={'waterway-summary-details-menu'}
                    noIcon={true}
                    title={'Peak Flow Q'}
                    isOpen={true}
                >
                    <PeakFlowQDetails className="" toolName=""></PeakFlowQDetails>
                </CollapseMenu>
                <CollapseMenu
                    titleClass={'waterway-summary-details-menu'}
                    noIcon={true}
                    title={'Reaches Warning'}
                    isOpen={true}
                >
                    <ReachesWarnDetails className="" toolName=""></ReachesWarnDetails>
                </CollapseMenu>
            </div>
        );
    }
    else {
        if (props.title === undefined && props.design !== 4) {
            return (
                <div className='Terrace-Summary-Details'>
                    <CollapseMenu
                        titleClass={'terrace-summary-details-menu'}
                        noIcon={true}
                        title={'Surface Warning'}
                        isOpen={true}
                    >
                        <GroundSurfaceDetails className="Terrace" toolName="Terrace"></GroundSurfaceDetails>
                    </CollapseMenu>
                    <CollapseMenu
                        titleClass={'terrace-summary-details-menu'}
                        noIcon={true}
                        title={'Alignment Warning'}
                        isOpen={true}
                    >
                        <AlignmentWarnDetails className="Terrace" toolName="Terrace"></AlignmentWarnDetails>
                    </CollapseMenu>
                    <CollapseMenu
                        titleClass={'terrace-summary-details-menu'}
                        noIcon={true}
                        title={'Hydrology Warning'}
                        isOpen={true}
                    >
                        <PeakFlowQDetails className="Terrace" toolName="Terrace"></PeakFlowQDetails>
                    </CollapseMenu>
                    <CollapseMenu
                        titleClass={'terrace-summary-details-menu'}
                        noIcon={true}
                        title={'Design Controls Warning'}
                        isOpen={true}
                    >
                        <PlaceholderDesignControlDetailsforTerrace className="" toolName=""></PlaceholderDesignControlDetailsforTerrace>
                    </CollapseMenu>
                    <CollapseMenu
                        titleClass={'terrace-summary-details-menu'}
                        noIcon={true}
                        title={'Reaches Warning'}
                        isOpen={true}
                    >
                        <ReachesWarnDetails className="Terrace" toolName="Terrace"></ReachesWarnDetails>
                    </CollapseMenu>
                </div>
            )
        }
    }
    if (props.design === 4 && props.title !== "" && props.title !== undefined) {
        return (
            <div>
                {props.title === 'Ground Surface' && <GroundSurfaceDetails className="Waterway" toolName="Waterway" />}
                {props.title === 'Surface' && <GroundSurfaceDetails className="Terrace" toolName="Terrace" />}
                {props.title === 'Alignment' && <AlignmentWarnDetails className="Waterway" toolName="Waterway" />}
                {props.title === 'Design Controls' && <DesignControlsWarnDetails className="Waterway" />}
                {props.title === 'Peak Flow Q' && <PeakFlowQDetails className="Waterway" toolName="Waterway" />}
                {props.title === 'Hydrology' && <PeakFlowQDetails className="Terrace" toolName="Terrace" />}
                {props.title === 'Reaches' && <ReachesWarnDetails className="Waterway" toolName="Waterway" />}
            </div>
        );
    }
    else {
        if (props.design !== 4 && props.title !== "" && props.title !== undefined) {
            return (
                <div>
                    {props.title === 'Ground Surface' && <GroundSurfaceDetails className="Terrace" toolName="Terrace" />}
                    {props.title === 'Surface' && <GroundSurfaceDetails className="Terrace" toolName="Terrace" />}
                    {props.title === 'Alignment' && <AlignmentWarnDetails className="Terrace" toolName="Terrace" />}
                    {props.title === 'Design Controls' && <PlaceholderDesignControlDetailsforTerrace className="" toolName="" />}
                    {props.title === 'Peak Flow Q' && <PeakFlowQDetails className="Terrace" toolName="Terrace" />}
                    {props.title === 'Hydrology' && <PeakFlowQDetails className="Terrace" toolName="Terrace" />}
                    {props.title === 'Reaches' && <ReachesWarnDetails className="Terrace" toolName="Terrace" />}
                </div>
            );
        }
    }

    // Default return for cases where no conditions are met
    return <div>No content to display</div>;
};